import React from "react";

// Metadata
// NOTE: these values are also in templates/frontend/icons_landing.html
export const titleTag =
    "Free Icons and Royalty-Free Images For Everyone | Noun Project";
export const metaDescription =
    "Noun Project features the most diverse collection of icons ever. Download SVG and PNG. Millions of free icons or unlimited royalty-free icons with NounPro.";

// Section 1
import heroTabletMobileImg from "./images/hero-small.png";
import heroDesktopTabletSvg from "./images/large-background-icons.svg";

import Icon from "core/ReusableIcons/Icon";
import Eye from "core/ReusableIcons/Eye";
import Artist from "core/ReusableIcons/Artist";

export const heroImages = {
    desktop: heroDesktopTabletSvg,
    tablet: heroDesktopTabletSvg,
    mobile: heroTabletMobileImg
};

// NOTE: these values are also in templates/frontend/icons_landing.html
export const heroHeading =
    "The World’s Most Diverse and Extensive Icon Collection";

// Section 2
export const bullets = [
    {
        icon: <Icon size="xl" />,
        title: "Icons for Everything",
        text:
            "Over 3 million art-quality free icons to make any idea more memorable. From astronauts to zebras, we've got you covered."
    },
    {
        icon: <Eye size="xl" />,
        title: "Curated & Accessible",
        text:
            "Each icon is professionally curated for quality, diversity and inclusion. Download as PNG or SVG file for easy editing."
    },
    {
        icon: <Artist size="xl" />,
        title: "Support Global Artists",
        text:
            "Purchase royalty-free icons that transcend language and cultural boundaries, and support creators from 120+ countries."
    }
];

// Section 3: Icon Collections
import IconSetRenewableEnergy from "./images/icon-set-renewable-energy.svg";
import IconSetWheelchair from "./images/icon-set-on-wheelchair.svg";
import IconSetFuturisticTechnology from "./images/icon-set-futuristic-technology.svg";
import IconSetPlants from "./images/icon-set-plants.svg";
import IconSetIconathon from "./images/icon-set-iconathon.svg";
import IconSetAdventure from "./images/icon-set-adventure.svg";
import {
    SEARCH_ICONS,
    SEARCH_ICON_COLLECTIONS,
    BROWSE_ICONS_BY_TAG
} from "data/links";

export const collectionsTitle =
    "Over 3 million icons to communicate any idea, from the classroom to the boardroom.";

export const collections = [
    {
        title: "Renewable Energy",
        subtitle: null,
        url: `${SEARCH_ICONS}?q=renewable+energy`,
        imageSrcAndTitle: {
            imageSrc: IconSetRenewableEnergy,
            title: "Renewable Energy"
        },
        type: "primary"
    },
    {
        title: "Iconathon",
        subtitle: "Redefining Women Collection",
        url: `/Iconathon1/collection/redefining-women/`,
        imageSrcAndTitle: {
            imageSrc: IconSetIconathon,
            title: "Iconathon"
        },
        type: "darkMode"
    },
    {
        title: "Futuristic Technology",
        subtitle: null,
        url: `/vinzencestudio/collection/futuristic-technology/`,
        imageSrcAndTitle: {
            imageSrc: IconSetFuturisticTechnology,
            title: "Futuristic Technology"
        },
        type: "primary"
    },
    {
        title: "Adventure",
        subtitle: null,
        url: `${SEARCH_ICONS}?q=adventure`,
        imageSrcAndTitle: {
            imageSrc: IconSetAdventure,
            title: "Adventure"
        },
        type: "primary"
    },
    {
        title: "On Wheelchair",
        subtitle: null,
        url: "/barrizon/collection/on-wheelchair/",
        imageSrcAndTitle: {
            imageSrc: IconSetWheelchair,
            title: "On Wheelchair"
        },
        type: "primary"
    },
    {
        title: "Plants",
        subtitle: null,
        url: `${SEARCH_ICON_COLLECTIONS}?q=plants`,
        imageSrcAndTitle: {
            imageSrc: IconSetPlants,
            title: "Plants"
        },
        type: "primary"
    }
];

export const pillsTitle = "Explore Trends";
export const pills = [
    {
        title: "Person",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "person")
    },
    {
        title: "Nature",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "nature")
    },
    {
        title: "Teamwork",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "teamwork")
    },
    {
        title: "Idea",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "idea")
    },
    {
        title: "Health",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "health")
    },
    {
        title: "Animal",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "animal")
    },
    {
        title: "Party",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "party")
    },
    {
        title: "Student",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "student")
    },
    {
        title: "Social Media",
        url: BROWSE_ICONS_BY_TAG.replace(":term", "social-media")
    }
];

// Section 4: Icon Highlights
import IconPhotoOne from "./images/design-infographics.png";
import IconPhotoTwo from "./images/creator-spotlight-luis-prado.png";
import IconPhotoThree from "./images/free-resources-educators.png";

export const iconHighlightTitle = "Icon Highlights";
export const iconHighlightsData = [
    {
        title: "How to Design an Effective Infographic",
        category: "Tutorials",
        imgSrc: IconPhotoOne,
        url:
            "https://blog.thenounproject.com/how-to-design-an-effective-infographic-with-icons-f6f9723d66dc",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Creator Spotlight: Luis Prado",
        category: "Spotlight",
        imgSrc: IconPhotoTwo,
        url:
            "https://blog.thenounproject.com/creator-spotlight-luis-prado-173f7f98de17",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Free Resources for Educators",
        category: "Templates",
        imgSrc: IconPhotoThree,
        url:
            "https://blog.thenounproject.com/free-resources-for-teachers-a6a1e32351e6",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];
